/** Whether the user prefers reduced motion (no smooth scroll / animation). */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

export function scrollBehaviorReducedAware(): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}
